module.exports = __webpack_public_path__ + "static/img/btn_Synthesis_2.e976479.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pt/btn_Synthesis_2.png
// module id = dG5G
// module chunks = 0